<template>
  <v-col>
    <v-col cols="12">
      <v-toolbar color="grey lighten-3">
        <v-toolbar-title>Event templates</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn small fab color="primary" @click="onAddSelectionEventTemplate">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel v-for="(eventTemplate, index) in selectionEntry.eventTemplates" :key="index">
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-fade-transition leave-absolute>
                <v-row no-gutters align="center">
                  <v-col cols="3">
                    <v-chip v-if="open" key="0" small color="primary">
                      {{ eventTemplate.id }}
                    </v-chip>
                    <v-chip v-else key="1" small color="primary">
                      {{ eventTemplate.id }}
                    </v-chip>
                  </v-col>

                  <v-col cols="8">
                    <v-chip
                      class="ma-1"
                      v-for="chipEventTemplateSerie in eventTemplate.series"
                      :key="chipEventTemplateSerie.id"
                      small
                      color="primary"
                    >
                      {{ chipEventTemplateSerie.id }}
                    </v-chip>
                  </v-col>

                  <v-spacer> </v-spacer>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon @click="onDeleteSelectionEventTemplate(index)">mdi-close-thick</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-fade-transition>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p></p>

            <v-combobox v-model="eventTemplate.id" :items="getEventClass()" chips></v-combobox>
            <p></p>

            <!-- event template -->
            <v-combobox
              :value="eventTemplate.series.map(s => s.id)"
              :items="getEventTemplateAll()"
              @change="updateSerieStructure($event, eventTemplate)"
              multiple
              chips
            ></v-combobox>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>

    <!-- Category -->
    <v-col cols="12">
      <v-toolbar color="grey lighten-3">
        <v-toolbar-title>Categories</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn small fab color="primary" @click="onAddSelectionCategory">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel v-for="(categoryGroup, index) in selectionEntry.categories" :key="index">
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-fade-transition leave-absolute>
                <v-row no-gutters>
                  <v-col cols="3">
                    <v-chip v-if="open" key="0" small color="primary">
                      {{ categoryGroup.id }}
                    </v-chip>
                    <v-chip v-else key="1" small color="primary">
                      {{ categoryGroup.id }}
                    </v-chip>
                  </v-col>

                  <v-col cols="8">
                    <v-chip
                      class="ma-1"
                      v-for="chipCategories in categoryGroup.values"
                      :key="chipCategories.id"
                      small
                      color="primary"
                    >
                      {{ chipCategories.id }}
                    </v-chip>
                  </v-col>

                  <v-spacer> </v-spacer>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon @click="onDeleteSelectionCategory(index)">mdi-close-thick</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-fade-transition>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p></p>

            <v-combobox v-model="categoryGroup.id" label="Name" :items="getCategoryClass()" chips></v-combobox>
            <p></p>
            <v-combobox
              v-model="categoryGroup.values"
              :items="getCategorySelection()"
              label="Series"
              item-text="id"
              item-value="id"
              multiple
              chips
            ></v-combobox>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-col>
</template>

<script>
  import * as helpers from '../shootingProgramHelpers.js';
  export default {
    name: 'EditSelectionsPanel',
    props: {
      selectionEntry: Object,
    },
    methods: {
      updateSerieStructure(newValues, eventTemplate) {
        eventTemplate.series = newValues.map(item =>
          typeof item === 'string' ? { id: item } : item
        );
      },
      getCategoryClass() {
        return helpers.getCategoryClass();
      },

      getCategorySelection() {
        return helpers.getCategorySelection();
      },
      getEventClass() {
        return helpers.getEventClass();
      },

      getEventTemplateAll() {
        return helpers.getEventTemplateAll();
      },
      onAddSelectionEventTemplate() {
        this.selectionEntry.eventTemplates.push({
          id: '',
          series: [],
        });
      },
      onDeleteSelectionEventTemplate(id) {
        this.$emit('onDeleteSelectionEventTemplate', id);
      },
      onAddSelectionCategory() {
        this.selectionEntry.categories.push({
          id: '',
          values: [],
        });
      },

      onDeleteSelectionCategory(id) {
        this.$emit('onDeleteSelectionCategory', id);
      },
    },
  };
</script>
